module.exports = __webpack_public_path__ + "img/logo-cambrige.17898383.png";